// extracted by mini-css-extract-plugin
export var languageSwitcher = "index-module--language-switcher--8a728";
export var languageSwitcher__item = "index-module--language-switcher__item--cc98b";
export var languageSwitcher__link = "index-module--language-switcher__link--f3b1d";
export var languageSwitcher__linkActive = "index-module--language-switcher__link--active--5ab7e";